export default __webpack_public_path__ + "static/media/gif_peer.7dc990fa.gif";